module.exports = __webpack_public_path__ + "media/images/kaimana_beach-5c326a49.jpg";